import React from "react";
import dayjs from "dayjs";
import MonthDayWeather from "./monthDaySections/monthDayWeather/monthDayWeather";
import MonthDayEvents from "./monthDaySections/monthDayEvents/monthDayEvents";
import MonthDayRevenue from "./monthDaySections/monthDayRevenue/monthDayRevenue";
import "./monthDay.css";
import MonthDayOpenDaily from "./monthDaySections/monthDayOpenDaily/monthDayOpenDaily";

type CalendarDayProps = {
  day: dayjs.Dayjs;
};

const MonthDay: React.FC<CalendarDayProps> = ({ day }) => {
  return (
    <div className="month-calendar-day">
      <div className="month-day-header" style={{ fontWeight: "bold" }}>
        {day.date()}
      </div>
      <div className="month-day-grid">
        <div className="month-day-grid-item">
          <MonthDayRevenue day={day} />
        </div>
        <div className="month-day-grid-item">
          <MonthDayOpenDaily day={day} />
        </div>
        <div className="month-day-grid-item">
          <MonthDayEvents day={day} />
        </div>
        <div className="month-day-grid-item">
          <MonthDayWeather day={day} />
        </div>
      </div>
    </div>
  );
};

export default MonthDay;
